import React, { useState } from 'react'
import { useInAppNotificationStyles } from '../../../hooks/styles/useInAppNotificationStyles'
import { useNotificationsHomeContext } from '../../context'
import { useBaseStyles } from '../../../hooks/styles/useBaseStyles'
import { NotificationIcon } from './NotificationIcon'
import { NotificationContent } from './NotificationContent'
import { NotificationActionButtons } from './NotificationActionButtons'
import { NotificationTime } from './NotificationTime'
import { NotificationActions } from './NotificationActions'
import { NotificationMedia } from './NotificationMedia'
import MemoPushPin from '../Icons/PushPin'

const LinkWrapper = ({
  children,
  link,
  hover = false,
  sameTab = 'false',
  item
}) => {
  const hasAttachment = link?.length > 0 && hover

  const {
    handlers: { handleMarkAsRead }
  } = useNotificationsHomeContext()

  const [showHover, setShowHover] = useState(false)

  const handleMouseEnter = () => {
    if (hasAttachment) {
      setShowHover(true)
    }
  }

  const handleMouseLeave = () => {
    setShowHover(false)
  }

  if (!hasAttachment) {
    // If no attachment, render children as-is
    return <div>{children}</div>
  }

  return (
    <div
      onClick={(e) => {
        handleMarkAsRead(item)
        if (sameTab === 'true') {
          window.open(link, '_self')
        } else {
          window.open(link, '_blank')
        }
        e.stopPropagation()
        e.preventDefault()
      }}
      style={{
        position: 'relative',
        cursor: 'pointer',
        display: 'inline-block'
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        style={{
          transition: 'filter 0.2s ease-in-out',
          filter: showHover ? 'brightness(70%) blur(0.5px)' : 'none'
        }}
      >
        {children}
      </div>

      {showHover && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0,
            bottom: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            borderRadius: '4px',
            zIndex: 10,
            pointerEvents: 'none'
          }}
        >
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='white'
            style={{
              fontSize: '1rem'
            }}
          >
            <path d='M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' />
          </svg>
        </div>
      )}
    </div>
  )
}

export const InAppNotification = ({ item, hideFooter = false, index }) => {
  const { InAppMessageContainer, InAppMessageFooterContainer } =
    useInAppNotificationStyles()

  const { CustomFlexBox } = useBaseStyles()

  const type = item?.notification_content?.attachments?.type
  const read = item?.isRead
  let mainLink = item?.notification_content?.action?.href || null
  let sameTab = item?.notification_content?.action?.sameTab || false

  if (mainLink && mainLink[0] !== '/') {
    if (!(/^https:/.test(mainLink) || /^http:/.test(mainLink))) {
      if (/[a-zA-Z]\.[a-zA-Z]/.test(mainLink)) {
        mainLink = 'https://' + mainLink
      } else if (mainLink !== '#') {
        mainLink = '/' + mainLink
      } else {
        mainLink = null
        sameTab = 'true'
      }
    }
  } else {
    mainLink = null
    sameTab = 'true'
  }

  const {
    data: { brandLogo },
    handlers: { handleMarkAsRead }
  } = useNotificationsHomeContext()

  const createdAt = item?.createdAt

  const title = item?.notification_content?.title
  const body = item?.notification_content?.body
  const logo = item?.notification_content?.icon || brandLogo
  const isPinned = item?.notification_content?.is_pinned || false

  const attachmentsObject = item?.notification_content?.attachments
  const attachmentLink = attachmentsObject?.attachment

  const handleOpenNotificationInWindow = (e) => {
    e.stopPropagation()

    handleMarkAsRead(item)
    if (mainLink) {
      window.open(mainLink, sameTab === 'true' ? '_self' : '_blank')
    }
  }
  return (
    <InAppMessageContainer
      read={read}
      onClick={(e) => handleOpenNotificationInWindow(e)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleOpenNotificationInWindow(e)
        }
      }}
      role='button'
    >
      <CustomFlexBox alignItems='flex-start' gap='10px'>
        <div style={{ position: 'relative' }}>
          {logo ? <NotificationIcon logo={logo} /> : <div />}

          {isPinned && index < 3 && (
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                right: '-6px',
                opacity: '100%'
              }}
            >
              <MemoPushPin />
            </div>
          )}
        </div>

        <div style={{ width: '100%' }}>
          <NotificationContent title={title} body={body} />
          <NotificationActionButtons item={item} />
        </div>
        {attachmentsObject && (
          <CustomFlexBox
            flexDirection='column'
            alignItems='flex-end'
            justifyContent='space-between'
          >
            <LinkWrapper
              item={item}
              link={attachmentLink}
              hover
              sameTab='false'
            >
              <NotificationMedia
                type={type}
                attachmentsObject={attachmentsObject}
              />
            </LinkWrapper>
          </CustomFlexBox>
        )}
      </CustomFlexBox>

      {!hideFooter && (
        <InAppMessageFooterContainer msg={item}>
          <NotificationTime createdAt={createdAt} logo={logo} />
          <NotificationActions msg={item} />
        </InAppMessageFooterContainer>
      )}
    </InAppMessageContainer>
  )
}
